import { render } from "./HistoryShiftCardSkeleton.vue?vue&type=template&id=5ad4e8c2"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__